var map = {
	"./bgm.mp3": 80529,
	"./bonichan.mp3": 9603,
	"./bot-1.mp3": 61010,
	"./bot-2.mp3": 67909,
	"./computer-hover.mp3": 46975,
	"./curtain-hover.mp3": 53788,
	"./curtain-open.mp3": 87462,
	"./door-close.mp3": 59358,
	"./door-enter.mp3": 42896,
	"./door-open.mp3": 61682,
	"./go-backroom.mp3": 33212,
	"./hover.mp3": 48193,
	"./lady-1.mp3": 47539,
	"./ohthisbot.mp3": 11343,
	"./old-1.mp3": 64598,
	"./old-2.mp3": 10985,
	"./old-hover-1.mp3": 7971,
	"./old-hover-2.mp3": 37804,
	"./old-hover-3.mp3": 95665,
	"./paper.mp3": 14453
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 46981;